import {type FunctionalComponent, h} from '@stencil/core';
import type { GuidedUiSkeleton } from '../../models/Guided.schema';

type SkeletonProps = Omit<GuidedUiSkeleton,'type'|'showWhen'>;

export const GuidedSkeleton: FunctionalComponent<SkeletonProps> = (props) => {
    const {
      resultSlots,
      itemWidth,
      itemHeight,
    } = props;
    let height = String(itemHeight ?? '1em');
    if(typeof itemHeight === 'number'){
      height = `${itemHeight}px`;
    }
    let width = String(itemWidth);
    if(typeof itemWidth === 'number'){
      width = `${itemWidth}px`;
    }
    let displayMode = 'block';
    switch(props.displayMode){
    case 'inline':
    case 'inline-block':
      displayMode = props.displayMode;
    }


    return <div class="guided-v2-skeleton">
      {props.label && <div class="guided-v2-skeleton__label">{props.label}</div>}
      {Array.from({ length: resultSlots }).map((_) => (
        <div class="guided-v2-skeleton__item" style={{
          '--skel-width': width,
          '--skel-height': height,
          'display': displayMode,
        }}></div>
      ))}
    </div>;
};
